export default "__VITE_ASSET__BEQEnmU0__"